import React from "react";
import classnames from "classnames";
const clsPrefix = "rc-Month";


const RenderHeader = ({ date }) => {
  return (
    <header key="header" className={classnames(`${clsPrefix}-header`)}>
      {date.format("MMMM YYYY")}
    </header>
  );
};
export default RenderHeader;
